export default "__VITE_ASSET__B6LPnWa7__"